module.exports = __webpack_public_path__ + "static/media/Fresh_Hazel_Lens.00ae4de7.png";